export default __webpack_public_path__ + "static/media/image14.114a7e46.png";